<template>
    <div>
        <div class="pt-2 mx-8">
            <!-- 已处理记录区域 -->
            <div class="collapse bg-base-100 mb-8" v-if="detailData.delete.length > 0">
                <input type="checkbox" v-model="isDelete" />
                <div class="collapse-title text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ $tt('已处理记录') }}</div>
                        <div class="badge badge-success gap-2 ml-2">
                            {{ detailData.delete_count }}
                        </div>
                    </div>
                </div>
                <div class="collapse-content">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-sm text-base-content/70">
                            <i class="fas fa-check-circle mr-1"></i>
                {{ $tt('以下艺术家已被成功合并，操作不可撤销') }}
                        </div>
                    </div>

                    <div class="space-y-4">
                        <div v-for="(item, index) in detailData.delete" :key="'deleted' + index"
                            class="card bg-base-100 border border-base-300">
                            <div class="card-body p-4">
                                <div class="flex items-center justify-between mb-3">
                                    <h3 class="card-title text-lg">{{ item.name }}</h3>
                                    <div class="badge badge-success text-primary-content">{{ $tt('已合并') }}</div>
                                </div>

                                <div class="bg-success/10 p-3 rounded-lg">
                                    <div class="flex items-center justify-between mb-2">
                                        <h4 class="font-semibold text-success">{{ $tt('合并信息') }}</h4>
                                        <span class="text-xs text-base-content/60">#{{ index + 1 }}</span>
                                    </div>
                                    <div class="text-sm text-base-content mb-2">
                                        <div class="flex items-center mb-1">
                                            <i class="fas fa-user mr-2 text-base-content/60"></i>
                                            <span class="font-medium">{{ $tt('主艺术家：') }}</span>
                                        </div>
                                        <div class="truncate ml-6 text-base-content/70 line-through" :title="item.name">
                                            {{ item.name }}
                                        </div>
                                    </div>
                                    <div class="text-sm text-base-content">
                                        <div class="flex items-center mb-1">
                                            <i class="fas fa-arrow-right mr-2 text-success"></i>
                                            <span class="font-medium">{{ $tt('合并到：') }}</span>
                                        </div>
                                        <div class="ml-6 text-base-content/70">
                                            {{ item.reason }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 相似艺术家合并区域 -->
            <div class="collapse bg-base-100 mb-8" v-if="detailData.mode_success.length > 0">
                <input type="checkbox" v-model="isSuccess" />
                <div class="collapse-title text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ $tt('相似艺术家 (待合并处理)') }}</div>
                        <div class="badge badge-warning gap-2 ml-2">
                            {{ detailData.mode_success_count }}
                        </div>
                    </div>
                </div>
                <div class="collapse-content">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-sm text-base-content/70">
                            <i class="fas fa-info-circle mr-1"></i>
                    {{ $tt('这些艺术家名称相似，请选择要保留的主艺术家，其他相似艺术家将被合并到主艺术家') }}
                        </div>
                        <div class="flex gap-2">
                            <!-- <button class="btn btn-primary btn-sm" @click="handleSmartMerge">
                                {{ $tt('智能合并') }}
                            </button> -->
                            <!-- <button class="btn btn-outline btn-sm btn-primary" @click="toggleBatchSelectArtists('A')"
                                :class="{ 'btn-active': isBatchSelectedA }">
                                {{ $tt('批量选择艺术家A') }}
                            </button>
                            <button class="btn btn-outline btn-sm btn-neutral"
                                @click="toggleBatchSelectArtists('B')"
                                :class="{ 'btn-active': isBatchSelectedB }">
                                {{ $tt('批量选择艺术家B') }}
                            </button> -->
                        </div>
                    </div>

                    <div class="space-y-6">
                        <div v-for="(item, index) in detailData.mode_success" :key="'similar' + index"
                            class="card bg-base-100 border border-base-300 shadow-lg hover:shadow-xl transition-shadow duration-300">
                            <div class="card-body p-6">
                                <div class="flex items-center justify-between mb-4">
                                    <h3 class="card-title text-xl font-bold text-base-content flex items-center">
                                        <i class="fas fa-users mr-3 text-purple-500"></i>
                                        #{{ index + 1 }} {{ item.name }}
                                    </h3>
                                    <div class="badge badge-ghost px-3 py-2 text-sm font-semibold">
                                            {{ $tt('相似度: {percent}%', { percent: (item.similar * 100).toFixed(1) }) }}
                                    </div>
                                </div>

                                <div class="grid md:grid-cols-2 gap-6">
                                    <!-- 艺术家A (主艺术家) -->
                                    <div class="relative bg-gradient-to-br from-primary/0 to-primary/5 p-4 rounded-xl border border-primary/5 shadow-sm hover:shadow-md transition-all duration-300 hover:scale-[1.02] cursor-pointer" 
                                         @click="toggleArtistSelection(item.name)"
                                         :class="{ 'ring-1 ring-primary': selectedArtists.includes(item.name) }">
                                        <div class="absolute top-2 right-2" @click.stop>
                                            <input type="checkbox" :checked="selectedArtists.includes(item.name)"
                                                @change="toggleArtistSelection(item.name)" class="checkbox checkbox-sm checkbox-primary">
                                        </div>
                                        <div class="flex items-center mb-3">
                                            <div class="w-10 h-10 bg-primary rounded-full flex items-center justify-center mr-3 shadow-lg">
                                                <i class="fas fa-user text-primary-content text-sm"></i>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="font-bold text-primary text-lg mb-1">{{ $tt('艺术家 A') }}</h4>
                                                <div class="bg-primary/20 text-primary px-2 py-1 rounded-full text-xs font-medium inline-block">
                                        {{ $tt('主艺术家') }}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="bg-base-100/70 backdrop-blur-sm p-3 rounded-lg mb-3 border border-primary/30">
                                            <div class="flex items-center mb-2">
                                                <i class="fas fa-tag text-primary mr-2"></i>
                                                <span class="text-xs text-base-content/70 font-medium">{{ $tt('艺术家名称') }}</span>
                                            </div>
                                            <div class="text-sm text-base-content font-mono bg-base-200 p-2 rounded border truncate" :title="item.name">
                                                {{ item.name }}
                                            </div>
                                        </div>

                                        <div class="flex justify-end" @click.stop>
                                            <button class="btn btn-primary btn-sm btn-outline hover:bg-primary-500 hover:text-primary-content transition-all duration-200 shadow-sm"
                                                @click="confirmMergeToThis(item.reason, item.name, 'A')">
                                                {{ $tt('合并到此艺术家') }}
                                            </button>
                                        </div>
                                    </div>

                                    <!-- 艺术家B (相似艺术家) -->
                                    <div class="relative bg-gradient-to-br from-neutral/0 to-neutral/5 p-4 rounded-xl border border-neutral/5 shadow-sm hover:shadow-md transition-all duration-300 hover:scale-[1.02] cursor-pointer" 
                                         @click="toggleArtistSelection(item.reason)"
                                         :class="{ 'ring-1 ring-neutral': selectedArtists.includes(item.reason) }">
                                        <div class="absolute top-2 right-2" @click.stop>
                                            <input type="checkbox" :checked="selectedArtists.includes(item.reason)"
                                                @change="toggleArtistSelection(item.reason)" class="checkbox checkbox-sm checkbox-neutral">
                                        </div>
                                        <div class="flex items-center mb-3">
                                            <div class="w-10 h-10 bg-neutral rounded-full flex items-center justify-center mr-3 shadow-lg">
                                                <i class="fas fa-user text-primary-content text-sm"></i>
                                            </div>
                                            <div class="flex-1">
                                                <h4 class="font-bold text-neutral-content text-lg mb-1">{{ $tt('艺术家 B') }}</h4>
                                                <div class="bg-neutral/5 text-neutral-content px-2 py-1 rounded-full text-xs font-medium inline-block">
                                        {{ $tt('相似艺术家') }}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="bg-base-100/70 backdrop-blur-sm p-3 rounded-lg mb-3 border border-neutral/30">
                                            <div class="flex items-center mb-2">
                                                <i class="fas fa-tag text-neutral mr-2"></i>
                                                <span class="text-xs text-base-content/70 font-medium">{{ $tt('艺术家名称') }}</span>
                                            </div>
                                            <div class="text-sm text-base-content font-mono bg-base-200 p-2 rounded border truncate" :title="item.reason">
                                                {{ item.reason }}
                                            </div>
                                        </div>


                                        <div class="flex justify-end" @click.stop>
                                            <button class="btn btn-neutral btn-sm btn-outline hover:bg-neutral-500 hover:text-neutral-content transition-all duration-200 shadow-sm"
                                                @click="confirmMergeToThis(item.name, item.reason, 'B')">
                                                {{ $tt('合并到此艺术家') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 批量合并按钮 -->
                    <!-- <div class="mt-4 flex justify-center" v-if="selectedArtists.length > 0">
                        <button class="btn btn-primary btn-outline" @click="confirmBatchMerge">
                            <i class="fas fa-object-group mr-1"></i>合并选中的 {{ selectedArtists.length }} 个艺术家
                        </button>
                    </div> -->
                </div>
            </div>
        </div>

        <!-- 智能合并规则弹窗 -->
        <dialog id="smart_merge_modal" class="modal">
            <div class="modal-box">
                <h3 class="font-bold text-lg">{{ $tt('智能合并规则设置') }}</h3>
                <div class="py-4">
                    <div class="form-control">
                        <label class="label">
                            <span class="label-text">{{ $tt('合并优先级') }}</span>
                        </label>
                        <single-select v-model="mergeForm.priority" :options="translateOptions(priorityOptions)" :placeholder="$tt('请选择')">
                        </single-select>
                    </div>
                    <div class="form-control">
                        <label class="label">
                            <span class="label-text">{{ $tt('歌曲数量规则') }}</span>
                        </label>
                        <single-select v-model="mergeForm.trackRule" :options="translateOptions(trackRuleOptions)" :placeholder="$tt('请选择')">
                        </single-select>
                    </div>
                    <div class="form-control">
                        <label class="label">
                            <span class="label-text">{{ $tt('名称规则') }}</span>
                        </label>
                        <single-select v-model="mergeForm.nameRule" :options="translateOptions(nameRuleOptions)" :placeholder="$tt('请选择')">
                        </single-select>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-sm mr-2">{{ $tt('取消') }}</button>
                        <button class="btn btn-primary btn-sm" @click="confirmSmartMerge">{{ $tt('开始智能合并') }}</button>
                    </form>
                </div>
            </div>
        </dialog>

        <!-- 单个艺术家合并确认弹窗 -->
        <dialog id="single_merge_modal" class="modal">
            <div class="modal-box">
                <h3 class="font-bold text-lg text-primary">
                    <i class="fas fa-object-group mr-2"></i>{{ $tt('确认合并艺术家') }}
                </h3>
                <div class="py-4">
                    <div class="alert mb-4">
                        <span>{{ $tt('此操作将会把一个艺术家的所有歌曲和专辑转移到另一个艺术家下') }}</span>
                    </div>
                    <div class="bg-primary/10 p-3 rounded-lg border border-primary/30">
                        <div class="font-semibold text-primary mb-2 line-through">
                            {{ mergeConfirm.sourceArtist }} ({{ $tt(mergeConfirm.sourceLabel) }})
                        </div>
                        <div class="text-center my-2">
                            <i class="fas fa-arrow-down text-primary text-xl"></i>
                        </div>
                        <div class="font-semibold text-primary">
                            {{ $tt('合并到: {name} ({label})', { name: mergeConfirm.targetArtist, label: $tt(mergeConfirm.targetLabel) }) }}
                        </div>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-sm mr-2">{{ $tt('取消') }}</button>
                        <button class="btn btn-primary btn-sm text-primary-content" @click="executeSingleMerge">
                            {{ $tt('确认合并') }}
                        </button>
                    </form>
                </div>
            </div>
        </dialog>

        <!-- 批量合并确认弹窗 -->
        <dialog id="batch_merge_modal" class="modal">
            <div class="modal-box">
                <h3 class="font-bold text-lg text-primary">
                    {{ $tt('确认批量合并') }}
                </h3>
                <div class="py-4">
                    <div class="alert mb-4">
                        <i class="fas fa-exclamation-triangle"></i>
                        <span>{{ $tt('您即将合并 {count} 个艺术家，此操作不可撤销！', { count: selectedArtists.length }) }}</span>
                    </div>
                    <div class="max-h-64 overflow-y-auto">
                        <div v-for="(artist, index) in selectedArtists" :key="index"
                            class="bg-primary/10 p-2 rounded mb-2 border border-primary/30">
                            <div class="text-sm text-base-content">
                                {{ artist }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button class="btn btn-sm mr-2">{{ $tt('取消') }}</button>
                        <button class="btn btn-primary btn-sm text-primary-content" @click="executeBatchMerge">
                            {{ $tt('确认合并 {count} 个艺术家', { count: selectedArtists.length }) }}
                        </button>
                    </form>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script>
import SingleSelect from "@/components/iview/SingleSelect";
import SingleInput from "@/components/iview/SingleInput";

export default {
    name: 'artist-merge-log-detail',
    props: {
        detailData: { type: Object, required: true }
    },
    components: { SingleInput, SingleSelect },
    data() {
        return {
            id: this.$route.params.id,
            selectedArtists: [], // 批量选择的艺术家
            mergeConfirm: { // 单个合并确认信息
                sourceArtist: '',
                targetArtist: '',
                sourceLabel: '',
                targetLabel: ''
            },
            mergeForm: {
                priority: 'track_count',
                trackRule: 'more',
                nameRule: 'shorter'
            },
            priorityOptions: [
                { 'id': 'track_count', 'name': '按歌曲数量优先' },
                { 'id': 'album_count', 'name': '按专辑数量优先' },
                { 'id': 'name_length', 'name': '按名称长度优先' },
            ],
            trackRuleOptions: [
                { 'id': 'more', 'name': '保留歌曲多的艺术家' },
                { 'id': 'less', 'name': '保留歌曲少的艺术家' },
            ],
            nameRuleOptions: [
                { 'id': 'shorter', 'name': '保留名称较短的艺术家' },
                { 'id': 'longer', 'name': '保留名称较长的艺术家' },
            ],
        }
    },
    computed: {
        isSuccess() {
            console.log(this.detailData.mode_success)
            return this.detailData.mode_success.length > 0
        },
        isDelete() {
            return this.detailData.delete.length > 0
        },
        isBatchSelectedA() {
            const artistAList = this.detailData.mode_success.map(item => item.name)
            return artistAList.length > 0 && artistAList.every(artist => this.selectedArtists.includes(artist))
        },
        isBatchSelectedB() {
            const artistBList = this.detailData.mode_success.map(item => item.reason)
            return artistBList.length > 0 && artistBList.every(artist => this.selectedArtists.includes(artist))
        }
    },
    methods: {
        translateOptions(options) {
            return options.map(option => ({
                ...option,
                name: this.$tt(option.name)
            }))
        },
        // 获取艺术家歌曲数量 (这里需要根据实际数据结构调整)
        getArtistTrackCount(artistName) {
            // 这里应该从实际数据或API获取艺术家的歌曲数量
            return Math.floor(Math.random() * 100) + 1
        },

        // 获取艺术家专辑数量 (这里需要根据实际数据结构调整)
        getArtistAlbumCount(artistName) {
            // 这里应该从实际数据或API获取艺术家的专辑数量
            return Math.floor(Math.random() * 20) + 1
        },

        // 切换艺术家选择状态
        toggleArtistSelection(artistName) {
            const index = this.selectedArtists.indexOf(artistName)
            if (index > -1) {
                this.selectedArtists.splice(index, 1)
            } else {
                this.selectedArtists.push(artistName)
            }
        },

        // 切换批量选择艺术家A或B
        toggleBatchSelectArtists(artistType) {
            let artistList = []

            if (artistType === 'A') {
                artistList = this.detailData.mode_success.map(item => item.name)
            } else {
                artistList = this.detailData.mode_success.map(item => item.reason)
            }

            // 检查是否已经全部选中
            const allSelected = artistList.every(artist => this.selectedArtists.includes(artist))

            if (allSelected) {
                // 如果全部选中，则取消选择
                artistList.forEach(artist => {
                    const index = this.selectedArtists.indexOf(artist)
                    if (index > -1) {
                        this.selectedArtists.splice(index, 1)
                    }
                })
            } else {
                // 否则选中所有艺术家
                artistList.forEach(artist => {
                    if (!this.selectedArtists.includes(artist)) {
                        this.selectedArtists.push(artist)
                    }
                })
            }
        },

        // 确认合并到指定艺术家
        confirmMergeToThis(sourceArtist, targetArtist, targetLabel) {
            this.mergeConfirm = {
                sourceArtist: sourceArtist,
                targetArtist: targetArtist,
                sourceLabel: targetLabel === 'A' ? '艺术家 B' : '艺术家 A',
                targetLabel: targetLabel === 'A' ? '艺术家 A' : '艺术家 B'
            }
            document.getElementById('single_merge_modal').showModal()
        },

        // 执行单个艺术家合并
        executeSingleMerge() {
            this.handleMergeArtists([this.mergeConfirm.sourceArtist], this.mergeConfirm.targetArtist)
            document.getElementById('single_merge_modal').close()
        },

        // 智能合并
        handleSmartMerge() {
            document.getElementById('smart_merge_modal').showModal()
        },

        // 确认智能合并
        confirmSmartMerge() {
            try {
                this.$api.Task.mergeArtists({
                    log_id: this.id,
                    mode: 'smart',
                    rules: this.mergeForm
                }).then((res) => {
                    if (res.result) {
                        this.$myMsg.notify({
                            title: this.$tt('智能合并成功！'),
                            type: 'success',
                            time: 2000,
                        })
                        this.$parent.fetchDetails()
                    } else {
                        this.$myMsg.notify({
                            title: this.$tt('智能合并失败！'),
                            content: res.message,
                            type: 'error',
                            time: 2000,
                        })
                    }
                })
                document.getElementById('smart_merge_modal').close()
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        },

        // 确认批量合并
        confirmBatchMerge() {
            if (this.selectedArtists.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('请先选择要合并的艺术家'),
                    type: 'warning',
                    time: 2000,
                })
                return
            }
            document.getElementById('batch_merge_modal').showModal()
        },

        // 执行批量合并
        executeBatchMerge() {
            if (this.selectedArtists.length === 0) return

            // 批量合并需要用户指定目标艺术家，这里简单处理为合并到第一个选中的艺术家
            const targetArtist = this.selectedArtists[0]
            const sourceArtists = this.selectedArtists.slice(1)
            
            this.handleMergeArtists(sourceArtists, targetArtist)
            document.getElementById('batch_merge_modal').close()
        },

        // 艺术家合并处理
        handleMergeArtists(sourceArtists, targetArtist) {
            try {
                this.$api.Task.mergeArtists({
                    'log_id': this.id,
                    'source_artists': sourceArtists,
                    'target_artist': targetArtist,
                    'mode': 'manual'
                }).then((res) => {
                    if (res.result) {
                        this.$myMsg.notify({
                            title: this.$tt('合并成功！'),
                            type: 'success',
                            time: 2000,
                        })
                        this.$parent.fetchDetails()
                        // 从选中列表中移除已合并的艺术家
                        sourceArtists.forEach(artist => {
                            const index = this.selectedArtists.indexOf(artist)
                            if (index > -1) {
                                this.selectedArtists.splice(index, 1)
                            }
                        })
                    } else {
                        this.$myMsg.notify({
                            title: this.$tt('合并失败！'),
                            content: res.message,
                            type: 'error',
                            time: 2000,
                        })
                    }
                })
                return true
            } catch (e) {
                console.warn(e)
                return false
            }
        }
    }
}
</script>

<style scoped></style>
